module.exports = __webpack_public_path__ + "img/rwxt-img.2bd02362.png";